export { statsigExperimentManager } from './statsig-experiment.manager'
export { STATSIG_EXPERIMENTS } from '../../config/statsig-experiments.config'
export { IsomorphicStatsigProvider } from './statsig-provider.isomorphic'
export { useStatsigExperimentBucket, useStatsigExperiment } from './useStatsigExperiment'
export { useStatsigDynamicLocaleConfig } from './use-statsig-dynamic-locale-config.hook'
export { useTargetedStatsigExperiment } from './use-targeted-statsig-experiment'
export { matchSlugTargets, STATSIG_EXPERIMENT_TARGETS_CONFIG_KEYS } from './experiment-targets.types'
export type { SlugExperimentTarget, ExperimentTargetsSchema } from './experiment-targets.types'
export type { StatsigLocaleDynamicConfig } from '@src/config/localisation/statsig-locale-config.types'
